import React from "react";
import logo from "../assets/logo-white.png";

export default function Footer() {
  return (
    <footer style={{ background: "var(--navy-deep)" }}>
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-md-4">
            <img src={logo} alt="GAPNIX Solutions LLP" height="30" />
            <p className="mt-3" style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.9rem", maxWidth: 280 }}>
              Software consulting and systems integration for businesses
              running on more than one platform.
            </p>
          </div>
          <div className="col-md-4">
            <div className="mono-label mb-3" style={{ color: "rgba(255,255,255,0.5)" }}>Sitemap</div>
            <ul className="list-unstyled d-flex flex-column gap-2">
              {[
                ["Integration", "#integration"],
                ["Services", "#services"],
                ["Industries", "#industries"],
                ["Process", "#process"],
                ["Stack", "#stack"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.92rem" }}>{label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-md-4">
            <div className="mono-label mb-3" style={{ color: "rgba(255,255,255,0.5)" }}>Contact</div>
            <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.92rem" }}>contact@gapnix.net</p>
          </div>
        </div>
        <div className="d-flex justify-content-between flex-wrap gap-2 pt-4 mt-4" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          <span style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.82rem" }}>
            © {new Date().getFullYear()} GAPNIX SOLUTIONS LLP. All rights reserved.
          </span>
        </div>
      </div>
      <div className="footer-tagline-bar text-center">
        <span className="mono-label">INTEGRATE | DESIGN | BUILD | DELIVER</span>
      </div>
    </footer>
  );
}
